import axios from "axios";

export default function confirmRecoverEmail(code) {
  return axios.post("/confirm-recover-email", { code });
}
